import type { ReactNode } from 'react';

import Overlay from '@/components/overlay';
import { cn } from '@/utils/cn';

interface BackdropProps {
  isOpen: boolean;
  isChildrenBottomLeft?: boolean;
  children: ReactNode;
}

const Backdrop: React.FC<BackdropProps> = ({ isOpen, isChildrenBottomLeft, children }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className={cn('fixed inset-0 flex justify-center p-4 z-60', isChildrenBottomLeft ? 'items-end' : 'items-start')}>
      <Overlay />
      <div className={cn('relative w-full flex', isChildrenBottomLeft ? 'justify-start' : 'justify-center')}>{children}</div>
    </div>
  );
};

export default Backdrop;
